import { useEffect } from 'react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom'

import * as Sentry from '@sentry/react'

import pkg from '../package.json'

Sentry.init({
	enabled: import.meta.env.PROD,
	dsn: 'https://67bde4cef5f64c75badd568c828e6a93@o4504547578937344.ingest.sentry.io/4504549658722304',
	release: pkg.version,
	environment: import.meta.env.MODE,
	integrations: [
		new Sentry.Replay({
			blockAllMedia: true,
			maskAllText: false,
		}),
		new Sentry.BrowserTracing({
			tracePropagationTargets: ['localhost', /^\//, 'api.glocal.workers.dev', 'api.gloc.al'],
			routingInstrumentation: Sentry.reactRouterV6Instrumentation(
				useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes
			),
		}),
	],
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
	tracesSampleRate: 1.0,
})
